var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 52,
    viewBox: "0 0 59 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5306 2.58799C32.5946 0.984046 30.8806 0 29.0202 0C27.1599 0 25.4458 0.98407 24.5099 2.58799L0.711086 43.3802C-0.231004 44.9957 -0.23707 46.9933 0.693363 48.6149C1.62939 50.236 3.35502 51.2378 5.22759 51.2378H52.8133C54.6859 51.2378 56.4115 50.236 57.3475 48.6149C58.2779 46.9933 58.2719 44.9958 57.3298 43.3802L33.5306 2.58799ZM29.9213 4.69553L53.7201 45.4877C53.9072 45.8123 53.9072 46.2115 53.7201 46.5361C53.5326 46.8603 53.1875 47.0571 52.813 47.0571H5.22732C4.85282 47.0571 4.5077 46.8603 4.3202 46.5361C4.13318 46.2115 4.13318 45.8123 4.3202 45.4877L28.119 4.69553C28.3065 4.37745 28.6456 4.18018 29.0201 4.18018C29.3946 4.18018 29.7336 4.37745 29.9211 4.69553H29.9213Z",
    fill: "#FF7A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9307 17.8071V32.4328C26.9307 33.5857 27.8667 34.5222 29.0201 34.5222C30.1734 34.5222 31.1095 33.5857 31.1095 32.4328V17.8071C31.1095 16.6542 30.1734 15.7181 29.0201 15.7181C27.8667 15.7181 26.9307 16.6542 26.9307 17.8071Z",
    fill: "#FF7A00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6322 40.2674C31.6322 41.71 30.463 42.8792 29.0204 42.8792C27.5779 42.8792 26.4087 41.71 26.4087 40.2674C26.4087 38.8249 27.5779 37.6557 29.0204 37.6557C30.463 37.6557 31.6322 38.8249 31.6322 40.2674Z",
    fill: "#FF7A00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.6bc7da1d6741efc243f1a66f536b072a.svg";
export { ForwardRef as ReactComponent };